
import { ShoppingList } from '@/types';
import { ShoppingListStorage } from './types';

export const shoppingListStorage: ShoppingListStorage = {
  loadFromStorage: (userId: string): ShoppingList | null => {
    try {
      const storedList = localStorage.getItem(`shoppingList_${userId}`);
      if (storedList) {
        return JSON.parse(storedList);
      }
      return null;
    } catch (error) {
      console.error('Error loading shopping list from localStorage:', error);
      return null;
    }
  },

  saveToStorage: (userId: string, shoppingList: ShoppingList): void => {
    try {
      localStorage.setItem(`shoppingList_${userId}`, JSON.stringify(shoppingList));
    } catch (error) {
      console.error('Error saving shopping list to localStorage:', error);
    }
  },

  removeFromStorage: (userId: string): void => {
    try {
      localStorage.removeItem(`shoppingList_${userId}`);
    } catch (error) {
      console.error('Error removing shopping list from localStorage:', error);
    }
  }
};
